<script lang="ts" module>
  import { getTooltipRootContext } from "./TooltipRoot.svelte"
  import type { TooltipContentImplProps } from "./internal/ContentImpl.svelte"

  export type TooltipContentProps = TooltipContentImplProps
</script>

<script lang="ts">
  import type { Snippet } from "svelte"
  import ContentHoverable from "./internal/ContentHoverable.svelte"
  import ContentImpl from "./internal/ContentImpl.svelte"

  type $$Props = TooltipContentProps
  interface Props {
    side?: $$Props["side"]
    children?: Snippet
    [key: string]: any
  }

  let { side = "top", children, ...rest }: Props = $props()

  const rootCtx = getTooltipRootContext()
</script>

{#if rootCtx.disableHoverableContent}
  <ContentImpl {side} {...rest}>
    {@render children?.()}
  </ContentImpl>
{:else}
  <ContentHoverable {side} {...rest}>
    {@render children?.()}
  </ContentHoverable>
{/if}
